import { useInstance, nextTick, createRef } from 'intact-vue-next';
import { useState, watchState } from '../../hooks/useState';
import { messages as globalMessages, classNames as globalClassNames } from './methods';
import { isFunction } from 'intact-shared';
import { createContext } from '../context';
// enum MessageOrClassname {
// Message,
// ClassName,
// }
export var context = createContext();
export function useError() {
  var instance = useInstance();
  var ellipsis = useState(false);
  var message = useState(undefined);
  var errorRef = createRef();
  watchState(message, function () {
    nextTick(checkEllipsis);
  });
  function checkEllipsis() {
    var error = errorRef.value;
    if (!error) return;
    ellipsis.set(error.offsetWidth < error.scrollWidth);
  }
  function getErrorMessageOrClassName(type, key) {
    var custom = instance.get(type);
    var value = custom && custom[key] || (type === 'messages' ? globalMessages[key] : globalClassNames[key]);
    if (isFunction(value)) {
      var rules = instance.get('rules');
      return value(instance.get('value'), rules[key]);
    }
    return value;
  }
  function getErrorMessage(key) {
    return getErrorMessageOrClassName('messages', key);
  }
  function getErrorClassName(key) {
    return getErrorMessageOrClassName('classNames', key);
  }
  function reset() {
    ellipsis.set(false);
    message.set(undefined);
  }
  return {
    ellipsis: ellipsis,
    message: message,
    errorRef: errorRef,
    getErrorMessage: getErrorMessage,
    getErrorClassName: getErrorClassName,
    reset: reset
  };
}